<template>
  <div>
    <div
        class="bg-white shadow-sm py-3 my-2"
        style="border-radius: 10px"
        id="sheba_page"
    >
      <div v-if="has_failed_to_sync_sheba_numbers" class="bg-warning text-dark pt-2 rounded mb-4 pb-1">
        <div class="mb-2 px-4">{{ $t('validation.failed_to_sync_sheba_numbers_error') }}</div>
        <ul>
          <li v-for="(sheba_number, index) in failed_to_sync_sheba_numbers" :key="index" v-text="sheba_number" class="text-dark"></li>
        </ul>
      </div>

      <div class="d-flex align-items-center px-3">
        <div class="ml-auto">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="#00bea5"
          >
            <g>
              <rect fill="none" height="24" width="24" />
            </g>
            <g>
              <g>
                <rect height="7" width="3" x="4" y="10" />
                <rect height="7" width="3" x="10.5" y="10" />
                <rect height="3" width="20" x="2" y="19" />
                <rect height="7" width="3" x="17" y="10" />
                <polygon points="12,1 2,6 2,8 22,8 22,6" />
              </g>
            </g>
          </svg>
          <span class="pr-2">{{ $t('label.bank_account') }}</span>
        </div>
        <div>
          <button
              type="button"
              class="btn btn-success px-4"
              style="border-radius: 10px"
              data-toggle="modal"
              data-target="#add_sheba_modal"
          >
            {{ $t('label.add_bank_account') }}
          </button>
        </div>
      </div>
      <hr />
      <div class="px-2">
        <div class="table-responsive">
          <table class="table table-borderless text-center">
            <thead>
            <tr>
              <th
                  scope="col"
                  style="background-color: #eee; border-radius: 0 16px 16px 0"
              >
                {{ $t('label.sheba_bank') }}
              </th>
              <th scope="col" style="background-color: #eee">{{ $t('label.sheba_number') }}</th>
              <th
                  scope="col"
                  style="background-color: #eee; border-radius: 16px 0 0 16px"
              >
                {{ $t('label.sheba_duty') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(bankAccount, index) in sheba_numbers" :key="index">
              <td>
                <div class="d-flex justify-content-center">
                  <div
                      class="border bg-bank border-dark rounded-circle p-2"
                      style="border-color: #a0a0a0 !important"
                  >
                    <img
                        :src="require('@/assets/new/banks_logos/' + getBankNickname(bankAccount.number) + '.png')"
                        alt="bank"
                        width="20"
                        height="20"
                    />
                  </div>
                  <div
                      class="pr-2 text-white-in-dark-mode"
                      v-text="getBankName(bankAccount.number)"
                  ></div>
                </div>
              </td>
              <td
                  class="align-middle en_num"
                  v-text="bankAccount.number"
              ></td>
              <td class="align-middle">
                <button
                    class="btn p-0 m-0 text-danger"
                    @click="deleteItem(bankAccount)"
                    :disabled="form_submit_loading"
                >
                  <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                    <span class="tooltip-text">{{ $t('label.sheba_remove') }}</span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="#ff6060"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"/></svg>
                    </span>
                  </span>
                </button>
                <button
                    v-if="bankAccount.bank_accounts_access && bankAccount.bank_accounts_access.status == 2"
                    class="btn p-0 m-0 text-danger"
                    :disabled="form_submit_loading"
                    @click="approveModal(bankAccount)"
                    id="deactivate_access"
                >
                  <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                    <span class="tooltip-text">{{ $t('label.deactivate_access') }}</span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#9d0303" class="bi bi-shield-slash" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.093 3.093c-.465 4.275.885 7.46 2.513 9.589a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.32 11.32 0 0 0 1.733-1.525l-.745-.745a10.27 10.27 0 0 1-1.578 1.392c-.346.244-.652.42-.893.533-.12.057-.218.095-.293.118a.55.55 0 0 1-.101.025.615.615 0 0 1-.1-.025 2.348 2.348 0 0 1-.294-.118 6.141 6.141 0 0 1-.893-.533 10.725 10.725 0 0 1-2.287-2.233C3.053 10.228 1.879 7.594 2.06 4.06l-.967-.967zM3.98 1.98l-.852-.852A58.935 58.935 0 0 1 5.072.559C6.157.266 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.483 3.626-.332 6.491-1.551 8.616l-.77-.77c1.042-1.915 1.72-4.469 1.29-7.702a.48.48 0 0 0-.33-.39c-.65-.213-1.75-.56-2.836-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524a49.7 49.7 0 0 0-1.357.39zm9.666 12.374-13-13 .708-.708 13 13-.707.707z"/>
                      </svg>
                    </span>
                  </span>
                </button>
                  <button
                    v-if="bankAccount.bank_accounts_access && bankAccount.bank_accounts_access.status == 4"
                    class="btn p-0 m-0 text-danger"
                    @click="activateAccess(bankAccount)"
                    :disabled="form_submit_loading"
                    id="activate_access"
                >
                  <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                    <span class="tooltip-text">{{ $t('label.activate_access') }}</span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#1f9d03" class="bi bi-shield-check" viewBox="0 0 16 16">
                        <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                        <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                      </svg>
                    </span>
                  </span>
                </button>
                <button
                    v-if="isAccessManageable(bankAccount.number)"
                    class="btn p-0 m-0 text-danger"
                    @click="bankAccountsManageAccess(bankAccount)"
                    :disabled="form_submit_loading"
                >
                  <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                    <span class="tooltip-text">{{ $t('label.bank_accounts_access') }}</span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#ADAAAAFF" class="bi bi-shield-lock" viewBox="0 0 16 16">
                        <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                        <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z"/>
                      </svg>
                    </span>
                  </span>
                </button>
                <button
                    class="btn p-0 m-0 text-danger"
                    @click="updateItem(bankAccount)"
                    :disabled="form_submit_loading"
                    data-toggle="modal"
                    data-target="#update_sheba_modal"
                >
                  <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm">
                    <span class="tooltip-text">{{ $t('label.sheba_edit') }}</span>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 17 17">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                      </svg>
                    </span>
                  </span>
                </button>
                  <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm" v-if="bankAccount.is_verified">
                      <span class="tooltip-text">{{ $t('label.inquiry_status') }}</span>
                      <img
                      src="@/pages/dashboard/userwizard/assets/check.svg"
                      width="16"
                      height="16"
                      class="filter_green"
                  />
                  </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- add Modal -->
    <div class="modal fade" id="add_sheba_modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">{{ $t('label.bank_accounts') }}</div>
            <form>
              <div class="form-group">
                <label for="add_sheba_modal_sheba" class="col-form-label"
                >{{ $t('label.sheba_number') }}</label
                >
                <div class="d-flex align-items-center mb-1 text-left" dir="ltr">
                  <div class="p-2">
                    <span>IR</span>
                  </div>
                  <input
                      type="text"
                      dir="ltr"
                      class="form-control en_num"
                      v-model="new_sheba"
                      id="add_sheba_modal_sheba"
                  />
                </div>
                 <div class="my-2">
                    <small class="py-2 badge badge-danger"> {{ $t('label.bank_account_info') }}</small>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                    type="button"
                    data-dismiss="modal"
                    @click.prevent="submitForm"
                    class="btn btn-success px-4"
                    style="border-radius: 10px"
                >
                  {{ $t('label.add_bank_account') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Update Modal -->
    <div class="modal fade" id="update_sheba_modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">{{ $t('label.bank_accounts_edit') }}</div>
            <form>
              <div class="form-group">
                <label for="update_sheba_modal_sheba" class="col-form-label"
                >{{ $t('label.sheba_number') }}</label
                >
                <div class="d-flex align-items-center mb-1 text-left" dir="ltr">
                  <div class="p-2">
                    <span>IR</span>
                  </div>
                  <input
                      type="text"
                      dir="ltr"
                      class="form-control en_num"
                      v-model="update_sheba_number.number"
                      id="update_sheba_modal_sheba"
                  />
                </div>
                 <div class="my-2">
                    <small class="py-2 badge badge-danger"> {{ $t('label.bank_account_info') }}</small>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                    type="button"
                    data-dismiss="modal"
                    @click.prevent="shebaUpdate()"
                    class="btn btn-success px-4"
                    style="border-radius: 10px"
                >
                  {{ $t('label.sheba_edit') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Bank accounts access Modal -->
    <div class="modal fade" id="bank_accounts_access" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">{{ $t('label.manage_bank_accounts_access') }}</div>
            <form class="px-5 py-3" id="bank_accounts_access_form">
              <div class="form-group">
                <label for="account_number" class="col-form-label">
                  {{ $t('label.account_number') }}
                </label>
                <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm rounded-circle">
                  <span class="tooltip-text">کاربر گرامی لطفا شماره حساب را با تمام جزئیات و کاراکتر ها وارد نمائید.</span>
                  <i class="fas fa-info-circle"></i>
                </span>
                <div class="mb-1 text-left">
                  <input
                      type="text"
                      :disabled="bank_accounts_access.status == 2"
                      dir="ltr"
                      name="account_number"
                      class="form-control en_num"
                      v-model="bank_accounts_access.account_number"
                      id="account_number"
                  />
                </div>
              </div>
              <div class="d-flex justify-content-center mt-2">
                <button
                    type="button"
                    id="bank_accounts_access_btn"
                    @click.prevent="storeBankAccountsAccess()"
                    class="btn btn-success px-4"
                    style="border-radius: 10px"
                >
                  {{ $t('label.give_access') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Deactivate access modal -->
    <Approve
        :message="$t('application.message.approval_message')"
        :data="approve_modal_data"
        @emitAction="deactivateAccess"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
import Inputmask from "inputmask";
import IranSheba from "iran-sheba";
import 'iranianbanklogos/dist/ibl.min.css'
import toastr from "toastr";
import { i18n } from "@/plugins/i18n";
import {bankAccountsAccessTokenService, walletService} from "@/common/api.service";
import {bankId} from "@/constants/bankId";
import Approve from "@/components/elements/modal/Approve.vue";
import alert from "@/components/elements/alert.vue";

export default {
  name: "sheba",
  components: {Approve},
  computed: {
    ...mapGetters("shebaNumber", ["sheba_numbers", "bankAccounts"]),
    toastr() {
        toastr.options = {
          closeButton: true,
          positionClass: "toast-bottom-center",
          preventDuplicates: false,
          rtl: false
        }

        return toastr
    }
  },
  mounted() {
      let track_code = this.$route.query.bank_account_access_tracking_code;
      if(track_code !== undefined && track_code !== null){
            bankAccountsAccessTokenService.fetchAccessTokenAuthorizationStatus(track_code)
                .then((response)=>{
                    this.toastr.success(response.data.message)
                })
                .catch( ({response}) => {
                    if (response.status >= 400 && response.status < 500)
                        this.toastr.error(response.data.message)
                    else
                        this.toastr.error('خطای سرور!')
                })
                .finally(()=>{
                    const currentQuery = { ...this.$route.query };
                    delete currentQuery['bank_account_access_tracking_code'];
                    this.$router.replace({ query: currentQuery });
                })
      }

    this.$store.dispatch("user/fetchCurrent");
    this.$store.dispatch("shebaNumber/fetchBankAccount");
    this.$store.dispatch("shebaNumber/fetch")
    this.$nextTick(function () {
      setTimeout(() => {
        Inputmask("9999-9999-9999-9999-9999-9999").mask(
            document.querySelectorAll("#add_sheba_modal_sheba")
        );
        Inputmask("9999-9999-9999-9999-9999-9999").mask(
            document.querySelectorAll("#update_sheba_modal_sheba")
        );
      }, 1000);
    });
  },
  data() {
    return {
      has_failed_to_sync_sheba_numbers: false,
      failed_to_sync_sheba_numbers: null,
      new_sheba: "",
      form_submit_loading: false,
      update_sheba_number: {},
      bank_accounts_access: {},
      approve_modal: false,
      approve_modal_data: {},
      manageAccessableBankNames: ['saderat', 'ayandeh', 'saman']
    };
  },
  methods: {
    approveModal(bankAccount){
      this.approve_modal_data = bankAccount
      $('#approve_modal').modal('show');
    },
    deactivateAccess(data){
      let btn = $('#approve_button')

      btn.prop('disabled', true)

      bankAccountsAccessTokenService.deactivateBankAccountsAccessAction(data.bank_accounts_access.id)
          .then((response) => {
            this.$store.dispatch("shebaNumber/fetch")
            this.toastr.success(response.data.message)
            $('#approve_modal').modal('hide');
          })
          .catch(({response}) => {
            if (response.status >= 400 && response.status < 500)
              this.toastr.error(response.data.message)
            else
              this.toastr.error('خطای سرور!')
          })
          .finally(() => {
            btn.prop("disabled", false);
          })
    },
    activateAccess(bankAccount) {
      let btn = $('#activate_access')

      btn.prop('disabled', true)
      bankAccountsAccessTokenService.activateBankAccountsAccessAction(bankAccount.bank_accounts_access.id)
          .then((response) => {
            this.$store.dispatch("shebaNumber/fetch")
            this.toastr.success(response.data.message)
          })
          .catch(({response}) => {
            if (response.status >= 400 && response.status < 500)
              this.toastr.error(response.data.message)
            else
              this.toastr.error('خطای سرور!')
          })
          .finally(() => {
            btn.prop("disabled", false);
          })
    },
    storeBankAccountsAccess(){
      let form = $('#bank_accounts_access_form')
      let btn = $('#bank_accounts_access_btn')

      form.validate({
        rules: {
          account_number: {
            required: true,
            number: true,
          }
        }
      })

      if(!form.valid()) {
        return
      }

      let params = {
          account_number: this.bank_accounts_access.account_number,
          iban_number: this.bank_accounts_access.iban_number
      }
      btn.prop("disabled", true);
      btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);
      const bankName = this.getBankNickname(this.bank_accounts_access.iban_number)
      if (bankName === 'ayandeh') {
          walletService.getAccessByOauthAyande(params).then(response => {
              window.location = response.data.data.oauth_url;
          }).catch(({response}) => {
              if (response.status >= 400 && response.status < 500)
                  this.toastr.error(response.data.message)
              else
                  this.toastr.error('خطای سرور!')
          }).finally(() => {
              btn.prop("disabled", false);
              btn.html(this.$t('label.save'));
          });
          return;
      }
      bankAccountsAccessTokenService.storeBankAccountsAccess(this.bank_accounts_access)
        .then((response) => {
          $('#bank_accounts_access').modal('hide')
          this.$store.dispatch("shebaNumber/fetch")
          this.toastr.success(response.data.message)
        })
        .catch((error) => {
          if (error.response.data.data)
            form.validate().showErrors(error.response.data.data)
          else
            this.toastr.error('خطای سرور!')
        })
        .finally(() => {
          btn.prop("disabled", false);
          btn.html(this.$t('label.save'));
        })
    },
    getBankName(sheba) {
      const bank = IranSheba.recognize(sheba);
      if (bank) {
        return bank.persianName;
      }
      return "";
    },
    getBankNickname(sheba) {

        sheba = 'IR'+sheba.replace(/-/g,'').replace(/IR/g,'')
      const bank = IranSheba.recognize(sheba);
      if (bank) {
        return bank.nickname;
      }
      return "central-bank"; // default value for when this function failed to recognize the bank name
    },
    submitForm(e) {
      if (this.new_sheba == "") return;

      if (!IranSheba.isValid("IR" + this.new_sheba.split("-").join(""))) {
        let el = $("#sheba_page");
        this.showMsg(el, "danger", i18n.t('validation.invalid_sheba_number'));
        this.new_sheba = "";
        return;
      }

      this.$store.dispatch('shebaNumber/createShebaNumebr',{sheba_number: this.new_sheba}).then(response => {
        this.toastr.success(response.data.message)
        this.$store.dispatch("shebaNumber/fetch")
      }).catch(({response}) => {
        this.toastr.error(response.data.message)
        for (let err in response.data.data) {
          this.toastr.error(response.data.data[err][0]);
        }
      }).finally(() => {
        this.new_sheba = ""
      })
    },

    deleteItem(bankAccount) {
      this.$store.dispatch('shebaNumber/deleteShebaNumber',bankAccount.id).then(response => {
          this.toastr.success(response.data.message)
          this.$store.dispatch("shebaNumber/fetch")
      }).catch(({response}) => {
          this.toastr.error(response.data.message)
      })
    },

    updateItem(bankAccount){
      this.update_sheba_number = {
        id: bankAccount.id,
        number: bankAccount.number.split("IR")[1]
      }
    },

    bankAccountsManageAccess(bankAccount){
      $('#bank_accounts_access').modal('show')
      this.bank_accounts_access = { ...this.bank_accounts_access, ...{
          id: bankAccount.bank_accounts_access ? bankAccount.bank_accounts_access.id : null,
          iban_number: 'IR' + bankAccount.number.replace(/-/g, ''),
          bank_id: bankId[this.getBankNickname(bankAccount.number)],
          account_number: bankAccount.bank_accounts_access ? bankAccount.bank_accounts_access.account_number : null,
          status: bankAccount.bank_accounts_access ? bankAccount.bank_accounts_access.status : null,
        }
      }
    },

    shebaUpdate(){

      if (this.update_sheba_number.number == "") return;

      if (!IranSheba.isValid("IR" + this.update_sheba_number.number.split("-").join(""))) {
        let el = $("#sheba_page");
        this.showMsg(el, "danger", i18n.t('validation.invalid_sheba_number'));
        this.update_sheba_number.number = "";
        return;
      }

      this.$store.dispatch('shebaNumber/updateShebaNumber',this.update_sheba_number).then(response => {
        this.toastr.success(response.data.message)
        this.update_sheba_number = {}
        this.$store.dispatch("shebaNumber/fetch")
      }).catch(({response}) => {
        this.toastr.error(response.data.message)
        for (let err in response.data.data) {
          this.toastr.error(response.data.data[err][0]);
        }
      })

    },
    isAccessManageable(bankNumber){
        const bankName = this.getBankNickname(bankNumber)
        return Object.values(this.manageAccessableBankNames).includes(bankName)
    },
  },
};
</script>

<style scoped>
.filter_green {
    filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg)
    brightness(91%) contrast(101%);
}
</style>
